import * as React from 'react';
import { InputProps, Label, FormGroup } from 'reactstrap';
import { Field, FieldProps } from 'formik';

export interface FormInputProps extends InputProps {
  label: React.ReactNode;
  name: string;
  id: string;
  form: any;
  checkInputs: any;
}

export class FormCheckInputArray extends React.Component<FormInputProps> {
  render() {
    const { id, label, name, checkInputs } = this.props;
    return (
      <Field name={name}>
        {({ field }: FieldProps<string[]>) => (
          <FormGroup>
            <Label for={id}>{label}</Label>
            {checkInputs.map((inpts: any) => (
              <div className="form-check" key={inpts.value}>
                <input
                  name={field.name}
                  type="checkbox"
                  id={inpts.value}
                  style={{ marginLeft: 0 }}
                  className="form-check-input"
                  checked={field.value.includes(inpts.value)}
                  onChange={() => {
                    const set = new Set(field.value);
                    if (set.has(inpts.value)) {
                      set.delete(inpts.value);
                    } else {
                      set.add(inpts.value);
                    }
                    let fromValue: any = Array.from(set);
                    field.onChange(field.name)(fromValue);
                  }}
                />
                <label className="form-check-label" htmlFor={inpts.value}>
                  <span className="block font-bold text-black">{inpts.title}</span>
                </label>
              </div>
            ))}
          </FormGroup>
        )}
      </Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/FormCheckInputArray.tsx